export default __webpack_public_path__ + "static/media/emily_gagne.c0c9f81f.jpeg";